export default class Modalmultisite {
	constructor() {
		const multisiteModal = document.querySelector('#multisite-modal');

		if (!sessionStorage.getItem('first-run')) {
			if (multisiteModal) {
				const exits = multisiteModal.querySelectorAll('.modal-exit');
				exits.forEach((exit) => {
					exit.addEventListener('click', () => {
						multisiteModal.classList.remove('open');
					});
				});
				const KEYCODE = {
					ESC: 27,
				};
				const checkKeys = (e) => {
					if (e.keyCode === KEYCODE.ESC) {
						multisiteModal.classList.remove('open');
					}
				};

				function openMultisiteModal() {
					multisiteModal.classList.add('open');
					sessionStorage.setItem('first-run', true);
				}
				setTimeout(openMultisiteModal, 500);

				document.addEventListener('keydown', checkKeys);
			}
		}
	}
}
